import React from "react";

const Card = ({ children, className = "", ...props }) => {
  return (
    <div
      className={`bg-white rounded-lg border border-gray-200 shadow-sm ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = "", ...props }) => {
  return (
    <div
      className={`px-6 py-4 border-b border-gray-200 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

const CardTitle = ({ children, className = "", ...props }) => {
  return (
    <h3
      className={`text-lg font-semibold text-gray-900 ${className}`}
      {...props}
    >
      {children}
    </h3>
  );
};

const CardContent = ({ children, className = "", ...props }) => {
  return (
    <div className={`px-6 py-4 ${className}`} {...props}>
      {children}
    </div>
  );
};

export { Card, CardHeader, CardTitle, CardContent };

const CardVariant = ({
  children,
  variant = "default",
  padding = "default",
  className = "",
  ...props
}) => {
  const variants = {
    default: "bg-white border-gray-200",
    elevated: "bg-white border-gray-200 shadow-md",
    outlined: "bg-white border-2 border-gray-300",
    ghost: "bg-transparent border-transparent",
  };

  const paddings = {
    none: "",
    sm: "p-4",
    default: "p-6",
    lg: "p-8",
  };

  return (
    <div
      className={`rounded-lg border shadow-sm ${variants[variant]} ${paddings[padding]} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

// Stats Card Component (commonly used in dashboards)
const StatsCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  trendDirection = "up",
  className = "",
}) => {
  const trendColors = {
    up: "text-green-600",
    down: "text-red-600",
    neutral: "text-gray-600",
  };

  return (
    <Card className={className}>
      <CardContent>
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
            <p className="text-2xl font-bold text-gray-900">{value}</p>
            {subtitle && (
              <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
            )}
            {trend && (
              <p
                className={`text-sm font-medium mt-2 ${trendColors[trendDirection]}`}
              >
                {trendDirection === "up"
                  ? "↗ "
                  : trendDirection === "down"
                  ? "↘ "
                  : "→ "}
                {trend}
              </p>
            )}
          </div>
          {Icon && (
            <div className="flex-shrink-0 ml-4">
              <Icon className="h-8 w-8 text-gray-400" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export { CardVariant, StatsCard };
